import { render, staticRenderFns } from "./elevatorFault.vue?vue&type=template&id=f5649d42&scoped=true&"
import script from "./elevatorFault.vue?vue&type=script&lang=js&"
export * from "./elevatorFault.vue?vue&type=script&lang=js&"
import style0 from "./elevatorFault.vue?vue&type=style&index=0&id=f5649d42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5649d42",
  null
  
)

export default component.exports